<template>
  <vs-col class="p-3" vs-w="3">
    <vs-card class="cursor-pointer" @click.native="onClick">
      <div slot="media">
        <img v-if="imageUrl" class="rounded-t-lg" :src="imageUrl" :alt="title" />
        <div v-else class="flex justify-center items-center rounded-t-lg w-full h-32 bg-white">
          <feather-icon icon="ArchiveIcon" class="w-8 h-8 text-grey" />
        </div>
      </div>
      <h6>{{ title }}</h6>
      <div class="text-sm whitespace-pre-wrap mt-2">{{ description }}</div>
    </vs-card>
  </vs-col>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    }
  }
};
</script>

<style lang="scss">
.card-image-custom {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-repeat: no-repeat;
  background-size: cover;
  height: 140px;
}
.card-image-background-color {
  background-image: linear-gradient(to right, rgba(var(--vs-primary), 0.7), rgba(var(--vs-primary), 1));
}
</style>